import { z } from 'zod';

import PreQualifyFormFields from '@enums/preQualifyForm';
import { nameValidation } from '@constants/validators';

export const PreQualifyFormSchema = z.object({
  [PreQualifyFormFields.FirstName]: nameValidation('First name'),
  [PreQualifyFormFields.LastName]: nameValidation('Last name'),
  [PreQualifyFormFields.Email]: z
    .string()
    .email({ message: 'Please enter a valid email address.' }),
});

export type PreQualifyFormValues = z.infer<typeof PreQualifyFormSchema>;
